import { iUser } from "@sdk/user-management/user-management.models";

export const getUserName = (user: iUser) => {
  return [user?.data.firstName, user?.data.lastName].filter(e => e).join(" ");
};

export const getUserGroups = (user: iUser) => {
  return user?.userGroups.join(",");
};
